import { Theme } from '@mui/material/styles';

export const sxFullSizeFlex = {
  display: 'flex',
  height: '100%',
  width: '100%',
};

export const containerSx = {
  bgcolor: 'background.default',
  ...sxFullSizeFlex,
};

// tooltip do not work correct with transform so switched to left
export const sxRightContainer = (transform: boolean, selectItem: boolean) => ({
  ...sxFullSizeFlex,
  left: '0',
  ...(transform && selectItem && { left: '-100%', transition: 'left 0.25s' }),
  minWidth: { xs: '100%', md: 'auto' },
  position: 'relative',
});

export const internalContainerSx = {
  bgcolor: 'background.paper',
  borderRadius: 2,
  m: 3,
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
};

export const leftSx = (transform: boolean, selectItem: boolean) => ({
  display: 'flex',
  flexDirection: 'column',
  width: { xs: '100%', md: '370px' },
  minWidth: { xs: '100%', md: '370px' },
  ...(transform && selectItem && { left: '-100%', transition: 'left 0.25s' }),
  position: 'relative',
});

export const iconSuccessSx = (theme: Theme) => ({
  color: theme.colorSchemes.dark?.palette.success.main,
});

export const sxDivider = {
  display: { xs: 'none', md: 'block' },
};
